var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007BB3",
    d: "m20.51 16.276-.095-.089c-.71-.675-1.772-1.568-1.772-2.5V9.632a6.9 6.9 0 0 0-5.837-6.585 6.61 6.61 0 0 0-7.449 6.5v4.147c0 .928-1.06 1.821-1.772 2.5l-.094.089a1.54 1.54 0 0 0-.339 1.79l.013.026A1.62 1.62 0 0 0 4.623 19H10a2 2 0 0 0 4 0h5.377a1.62 1.62 0 0 0 1.458-.908l.013-.026a1.54 1.54 0 0 0-.339-1.79"
  })));
};
export default SvgBell;